<template>
	<div class="user-menu">

		<div @click="tab(item)" class="item-box" v-for="(item,index) in meuns" :key="index">
			<div class="item" :class="item.title===title? 'active-item':''">
				<img :src="item.title===title ? item.iconCurImg : item.iconImg" class="icon-img" />
				<span class="title"> {{ item.title }} </span>
			</div>
			<div class="active" v-show="item.title===title"></div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'UserMenu',
		props: {},
		data() {
			return {
				title: '个人中心',
				meuns: [{
						title: '个人中心',
						path: 'center',
						iconImg: require('../assets/images/user/user.png'),
						iconCurImg: require('../assets/images/user/user_cur.png')
					},
					{
						title: '我的订单',
						path: 'order',
						iconImg: require('../assets/images/user/order.png'),
						iconCurImg: require('../assets/images/user/order_cur.png')
					},
					{
						title: '我的返修',
						path: 'fixing_list',
						iconImg: require('../assets/images/user/fixing.png'),
						iconCurImg: require('../assets/images/user/fixing_cur.png')
					},
					{
						title: '退款维权',
						path: 'refund',
						iconImg: require('../assets/images/user/refund.png'),
						iconCurImg: require('../assets/images/user/refund_cur.png')
					},
					{
						title: '地址管理',
						path: 'address',
						iconImg: require('../assets/images/user/address.png'),
						iconCurImg: require('../assets/images/user/address_cur.png')
					},
					{
						title: '量体数据',
						path: 'figure_body_list',
						iconImg: require('../assets/images/user/data.png'),
						iconCurImg: require('../assets/images/user/data_cur.png')
					},
					{
						title: '安全设置',
						path: 'security',
						iconImg: require('../assets/images/user/set.png'),
						iconCurImg: require('../assets/images/user/set_cur.png')
					},
					{
						title: '支付密码设置',
						path: 'pay_password',
						iconImg: require('../assets/images/user/pay_password.png'),
						iconCurImg: require('../assets/images/user/pay_password_cur.png')
					},
					{
						title: '退出登录',
						path: 'logout',
						iconImg: require('../assets/images/user/quit.png'),
						iconCurImg: require('../assets/images/user/quit_cur.png')
					}
				],

			};
		},
		watch: {
			$route(to) {
				let path = to.path.split('/')[2]
				this.meuns.forEach(item => {
					if (item.path === path) {
						this.title = item.title
					}
				})
			},
		},
		created() {
			let path = this.$route.path.split('/')[2]
			this.meuns.forEach(item => {
				if (item.path === path) {
					this.title = item.title
				}
			})
		},
		methods: {
			tab(e) {
				if(e.path == 'logout') {
					this.$store.commit('logout')
					this.$router.push({
						path: '/'
					})
					return
				}
				this.$router.push({
					path: '/user/' + e.path
				})
			}

		}
	}
</script>

<style scoped lang="scss">
	.user-menu {
		width: 200px;
		background: #FFFFFF;
		box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);
		opacity: 1;
		padding: 10px 0;

		.item-box {
			position: relative;
			display: flex;
			align-items: center;
			width: 200px;
			height: 50px;

			.item {
				width: 172px;
				height: 40px;
				display: flex;
				align-items: center;
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #666666;
				margin-left: 14px;
				border-radius: 6px;
				cursor: pointer;
				.icon-img {
					width: 20px;
					height: 20px;
					margin-left: 22px;
					margin-right: 12px;
				}

				&.active-item {
					background: #FBF5EB;
					font-size: 15px;
					font-weight: bold;
					color: #0F114A;
				}
			}

			.active {
				width: 4px;
				height: 40px;
				background: #EDD4AC;
				opacity: 1;
				border-radius: 2px;
				margin-left: 10px;
			}
		}
	}
</style>
